import {responseError} from './http';

export async function requireSessionAcknowledgement(response: Response, fallback: string): Promise<void> {
  if (!response.ok) throw await responseError(response, fallback);
  const payload: unknown = await response.json().catch(() => null);
  if (!payload || typeof payload !== 'object' || (payload as {authenticated?: unknown}).authenticated !== true) {
    throw new Error('The server could not confirm the secure workspace session. No saved browser credential has been removed.');
  }
}